import { render, staticRenderFns } from "./ImportantMessage.vue?vue&type=template&id=28b23e5e&scoped=true&"
import script from "./ImportantMessage.vue?vue&type=script&lang=js&"
export * from "./ImportantMessage.vue?vue&type=script&lang=js&"
import style0 from "./ImportantMessage.vue?vue&type=style&index=0&id=28b23e5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b23e5e",
  null
  
)

export default component.exports